"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _Route = require("../../provider/Route");

var RequireAuthentication = function RequireAuthentication(_ref) {
  var _ref$onLogin = _ref.onLogin,
      onLogin = _ref$onLogin === void 0 ? function () {} : _ref$onLogin,
      children = _ref.children;

  var _useAmplifyUser = (0, _Pc.useAmplifyUser)(),
      isAuthenticated = _useAmplifyUser.isAuthenticated;

  var _useContext = (0, _react.useContext)(_Route.RouteActionsContext),
      routeExternal = _useContext.routeExternal;

  (0, _react.useEffect)(function () {
    var executeRedirect = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isAuthenticated) {
                  routeExternal('pcLogin');
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function executeRedirect() {
        return _ref2.apply(this, arguments);
      };
    }();

    setTimeout(function () {
      executeRedirect();
    }, 300);
  }, [isAuthenticated, routeExternal]);
  return children;
};

var _default = RequireAuthentication;
exports.default = _default;